import { useEffect, useState } from 'react';

import { ActionPermissions } from '../../../../@types';
import { PartEditPermissions } from '../../../../components/templates/MainPartEdit';
import { isUserHasPermission } from '../../../../configs/permissions';
import { INIT_PART_EDIT_PERMISSIONS } from '../../../../constants/part';
import { useGetUserSystemPermissions } from '../../../../queries/user-query';

export const usePartEditPermissions = (): PartEditPermissions => {
  const [permissions, setPermissions] = useState<PartEditPermissions>(INIT_PART_EDIT_PERMISSIONS);
  const { data } = useGetUserSystemPermissions();

  useEffect(() => {
    if (!data) {
      // The permissions query has cleared (e.g. after logout or a refetch
      // failure). Drop back to the inert default so a previously-elevated user
      // can't keep using the form.
      setPermissions(INIT_PART_EDIT_PERMISSIONS);
      return;
    }
    setPermissions({
      isSerial: isUserHasPermission(ActionPermissions.Part_Serial, data),
      isCondition: isUserHasPermission(ActionPermissions.Part_Condition, data),
      isLocation: isUserHasPermission(ActionPermissions.Structure_Edit, data),
      isClientHierarchy: isUserHasPermission(
        ActionPermissions.Configure_Clients_or_Contracts_Edit,
        data
      ),
      isPartType: isUserHasPermission(ActionPermissions.Part_Change_Part_Type, data),
      isPartMerge: isUserHasPermission(ActionPermissions.Parts_Merge, data),
      isExceptionalAcceptance: isUserHasPermission(ActionPermissions.Part_Exception, data),
    });
  }, [data]);

  return permissions;
};
